export default "__VITE_ASSET__BKc1lwgz__"